module.exports = __webpack_public_path__ + "portal/static/img/krungthai.c5a8a6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/krungthai.png
// module id = wql4
// module chunks = 67